function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  y1: -0.136,
  x2: 1,
  y2: -0.136,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0c59a4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#114a8b"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient",
  cx: 0.552,
  cy: 0.509,
  r: 0.62,
  gradientTransform: "matrix(0.863, 0, 0, -0.95, 0.076, -0.457)",
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopOpacity: 0.529
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 0.906,
  y1: 0.521,
  x2: 0.245,
  y2: -0.063,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#1b9de2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#1595df"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#0680d7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0078d4"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-2",
  cx: 0.418,
  cy: 0.726,
  r: 0.69,
  gradientTransform: "matrix(0.185, -0.989, -0.986, -0.121, -1.622, -1.971)",
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopOpacity: 0.502
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-3",
  cx: 0.101,
  cy: 0.278,
  r: 1.188,
  gradientTransform: "matrix(-0.025, 0.999, 1.417, 0.08, -4.264, 2.626)",
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#35c1f1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.11,
  stopColor: "#34c1ed"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#2fc2df"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.31,
  stopColor: "#2bc3d2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#36c752"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-4",
  cx: 0.938,
  cy: 0.454,
  r: 0.571,
  gradientTransform: "matrix(0.187, 0.96, 0.52, -0.228, -0.535, 2.661)",
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#66eb6e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#66eb6e",
  stopOpacity: 0
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "edge-browser",
  transform: "translate(0.02 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M79.469,113.471a8.779,8.779,0,0,1-.987.441,9.539,9.539,0,0,1-3.362.6c-4.431,0-8.291-3.048-8.291-6.959A2.948,2.948,0,0,1,68.368,105c-4.008.169-5.038,4.345-5.038,6.792,0,6.918,6.376,7.619,7.75,7.619a9.985,9.985,0,0,0,2.528-.427l.123-.041A12.018,12.018,0,0,0,79.967,114a.375.375,0,0,0-.5-.528Z",
  transform: "translate(-57.852 -95.629)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M79.469,113.471a8.779,8.779,0,0,1-.987.441,9.539,9.539,0,0,1-3.362.6c-4.431,0-8.291-3.048-8.291-6.959A2.948,2.948,0,0,1,68.368,105c-4.008.169-5.038,4.345-5.038,6.792,0,6.918,6.376,7.619,7.75,7.619a9.985,9.985,0,0,0,2.528-.427l.123-.041A12.018,12.018,0,0,0,79.967,114a.375.375,0,0,0-.5-.528Z",
  transform: "translate(-57.852 -95.629)",
  opacity: 0.35,
  fill: "url(#radial-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M14.605,71.158a7.416,7.416,0,0,1-2.129-2,7.559,7.559,0,0,1,2.765-11.237,3.13,3.13,0,0,1,1.455-.375A3.029,3.029,0,0,1,19.1,58.766a2.985,2.985,0,0,1,.6,1.747c0-.02,2.29-7.454-7.491-7.454a7.865,7.865,0,0,0-7.491,7.323,12.187,12.187,0,0,0,1.134,5.244,11.986,11.986,0,0,0,14.643,6.284,7.074,7.074,0,0,1-5.879-.749Z",
  transform: "translate(-4.725 -48.552)",
  fill: "url(#linear-gradient-2)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M14.605,71.158a7.416,7.416,0,0,1-2.129-2,7.559,7.559,0,0,1,2.765-11.237,3.13,3.13,0,0,1,1.455-.375A3.029,3.029,0,0,1,19.1,58.766a2.985,2.985,0,0,1,.6,1.747c0-.02,2.29-7.454-7.491-7.454a7.865,7.865,0,0,0-7.491,7.323,12.187,12.187,0,0,0,1.134,5.244,11.986,11.986,0,0,0,14.643,6.284,7.074,7.074,0,0,1-5.879-.749Z",
  transform: "translate(-4.725 -48.552)",
  opacity: 0.41,
  fill: "url(#radial-gradient-2)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M18.874,18.859c-.076.1-.309.234-.309.53a.871.871,0,0,0,.442.677,7.68,7.68,0,0,0,3.892.813,5.577,5.577,0,0,0,2.834-.782,5.747,5.747,0,0,0,2.849-4.952,8.286,8.286,0,0,0-1.062-4.112C25.536,7.152,21.253,4.92,16.6,4.92A11.986,11.986,0,0,0,4.61,16.738c.045-3.423,3.446-6.186,7.491-6.186a9.06,9.06,0,0,1,3.933.943,6.8,6.8,0,0,1,2.889,2.735,6.023,6.023,0,0,1,.682,2.764A3.383,3.383,0,0,1,18.874,18.859Z",
  transform: "translate(-4.63 -4.92)",
  fill: "url(#radial-gradient-3)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  d: "M18.874,18.859c-.076.1-.309.234-.309.53a.871.871,0,0,0,.442.677,7.68,7.68,0,0,0,3.892.813,5.577,5.577,0,0,0,2.834-.782,5.747,5.747,0,0,0,2.849-4.952,8.286,8.286,0,0,0-1.062-4.112C25.536,7.152,21.253,4.92,16.6,4.92A11.986,11.986,0,0,0,4.61,16.738c.045-3.423,3.446-6.186,7.491-6.186a9.06,9.06,0,0,1,3.933.943,6.8,6.8,0,0,1,2.889,2.735,6.023,6.023,0,0,1,.682,2.764A3.383,3.383,0,0,1,18.874,18.859Z",
  transform: "translate(-4.63 -4.92)",
  fill: "url(#radial-gradient-4)"
}));

function SvgEdgeBrowser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.973,
    height: 23.976,
    viewBox: "0 0 23.973 23.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeBrowser);
export default __webpack_public_path__ + "static/media/edge-browser.05790c19.svg";
export { ForwardRef as ReactComponent };